import { Component, Input } from '@angular/core';
import { FacilityViewModel } from 'src/app/shared/models/autogenerated';

@Component({
    selector: 'app-facility-card',
    templateUrl: './facility-card.component.html',
    styleUrls: ['./facility-card.component.scss'],
    standalone: false
})
export class FacilityCardComponent {
  @Input()
  public facility: FacilityViewModel;
}
